<template>
  <div style="min-height: 92vh">
    <h3>Cajeros</h3>
    <uv-data-table
      :config="config"
      :data="cashiers"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></uv-data-table>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <CajerosForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";

import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import CajerosForm from "../Cajeros/CajerosForm.vue";

export default {
  name: "CajerosCrud",
  components: {
    modal,
    uvDataTable,
    CajerosForm,
  },
  props: [],
  data() {
    return {
      formIndex: 0,
      formHeight: 0,
      editMode: false,
      cashiers: [],
      editData: {},
      showModal: false,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Cajeros",
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar Cajero",
            icon: "lni lni-plus",
            buttonId: "addCajero",
            require: false,
          },
          {
            text: "Editar Cajero",
            icon: "lni lni-pencil-alt",
            buttonId: "editCajero",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "eliminarCajero",
            require: true,
          },
        ],
        fields: [
          {
            text: "No Cajero",
            value: "NCjr",
          },
          {
            text: "Nombre",
            value: "Nomb",
          },
          {
            text: "Departamentos",
            value: "Dpts",
            canBeFiltered: true,
            format: (row) => {
              return Object.keys(row.Dpts).join(", ");
            },
          },
          {
            text: "Estado",
            value: "Actv",
            canBeFiltered: true,
            format: (row) => {
              let html = "<a class='red' style='display: inline-block; padding: 1px 10px;font-size: 14px;font-weight: bold;color: white;border-radius: 16px;text-align: center;text-decoration: none;min-width: 80px;'>Inactivo</a>";
              if (row.Actv) {
                html = "<a class='green' style='display: inline-block; padding: 1px 10px;font-size: 14px;font-weight: bold;color: white;border-radius: 16px;text-align: center;text-decoration: none;min-width: 80px;'>Activo</a>";
              }

              return html;
            },
          },
          {
            text: "Fecha de Creación",
            value: "FeCr",
            format: (row) => {
              return moment(row.FeCr).format("DD MMM YYYY hh:mm a");
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addCajero") {
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Cajero");
        this.showModal = true;
      } else if (buttonId == "editCajero") {
        const cashier = this.getCajeroById(idSelected[0]);

        this.editMode = true;
        this.editData = cashier;
        this.$pgsHelper.log(this.editData);
        this.$refs.modalForm.setTitle(`Editando Cajero ${cashier.NCjr}`);
        this.showModal = true;
      } else if (buttonId == "eliminarCajero") {
        this.deleteCajero(idSelected[0]);
      }
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.addCajero(data);
      } else if (doAction == "EDIT") {
        this.editCajero(data);
      }
    },
    deleteCajero(Id) {
      const deletedObject = this.getCajeroById(Id) || { Id, Dpto: "ProShop" };
      let datos = { Id, Dpto: "ProShop" }; //localStorage.getItem("selectedDepartment");
      this.$swal({
        title: "¿Deseas eliminar este cajero?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-deleteCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_DELETE",
              Mensaje: "Cajero eliminado",
              reference: { id: Id, tp: "SEC-Cajero", al: "CAJERO" },
              data: deletedObject
            });
            this.getCashiers();
            this.$swal(
              "Cajero eliminado",
              "El cajero se eliminó correctamente",
              "success"
            );
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    addCajero(datos) {
      this.$swal({
        title: "¿Deseas guardar la información del cajero?",
        text: "El cajero se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar!",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-createCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const targetId = result.value.data.id || (result.value.data.data && result.value.data.data.id) || datos.Id;
            const cajeroName = datos.NCjr || datos.Nombre || "CAJERO";
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_CREATE",
              Mensaje: `Cajero creado: ${cajeroName}`,
              reference: { id: targetId, tp: "SEC-Cajero", al: cajeroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El Cajero se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.getCashiers();
              this.toggleModal(false);
            });
          } else {
            this.$swal("Error saving Cajero", result.value.data.error, "error");
          }
        }
      });
    },
    editCajero(datos) {
      this.$swal({
        title: "¿Deseas editar este cajero?",
        text: "Los cambios se verán reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Cajeros-updateCajero", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const cajeroName = datos.NCjr || datos.Nombre || "CAJERO";
            this.$pgsHelper.writeLog({
              Evento: "CAJERO_EDIT",
              Mensaje: `Cajero editado: ${cajeroName}`,
              reference: { id: datos.Id, tp: "SEC-Cajero", al: cajeroName },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El cajero se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getCashiers();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando Cajero",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    getCajeroById(code) {
      let itemIndex = this.$_.findIndex(this.cashiers, { Id: code });
      if (itemIndex >= 0) {
        return this.cashiers[itemIndex];
      }

      return false;
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getCashiers();
  },
};
</script>
